import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken, ok } from '../../utils/response';
import { errorResponse, okResponse } from '../../utils/response';
import { Token, UserCode, EmployeeCode, Company } from '../../utils/users';
import { encryption } from '../../utils/encryption';

export function getListEmergencyContact() {
    let url = 'emergencyContact/getListEmergencyContact?' + objectToQueryString({ userCode: encryption(UserCode()), employeeCode: encryption(EmployeeCode()), company: encryption(Company()), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse({ result: JSON.parse(response.result) });
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getEmergencyContactById(id) {
    let url = 'emergencyContact/getEmergencyContactById?' + objectToQueryString({
        userCode: encryption(UserCode()),
        emergencyContactId: encryption(id),
        company: encryption(Company()),
        token: Token()
    });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse({ result: JSON.parse(response.result) });
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getRelationshipList() {
    let url = 'emergencyContact/getRelationshipList?' + objectToQueryString({
        userCode: encryption(UserCode()),
        company: encryption(Company()),
        token: Token()
    });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse({ result: JSON.parse(response.result) });
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function saveEmergencyContact(emergencyContactId, priority, contact, phone, phoneOffice, extensionOffice, cellphone, email, other, relationshipEmployeeCode) {
    return fetch('emergencyContact/SaveEmergencyContact', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCodeCrypt: encryption(UserCode()),
            emergencyContactIdCrypt: encryption(emergencyContactId),
            employeeCodeCrypt: encryption(EmployeeCode()),
            companyCrypt: encryption(Company()),
            priority: priority,
            contact: contact,
            phone: phone,
            phoneOffice: phoneOffice,
            extensionOffice: extensionOffice,
            cellphone: cellphone,
            email: email,
            other: other,
            relationshipEmployeeCode: relationshipEmployeeCode,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse({ result: JSON.parse(response.result) });
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function deleteEmergencyContact(emergencyContactId) {
    return fetch('emergencyContact/DeleteEmergencyContact', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCodeCrypt: encryption(UserCode()),
            emergencyContactIdCrypt: encryption(emergencyContactId),
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return ok();
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}